module.exports = __webpack_public_path__ + "static/media/animated_praveen.01c4275c.png";